import styled from 'styled-components';

export const Container = styled.div`

  > img {
    width: 101px;
    height: 220px;
  }
`;
